import { Row, Col, Card, Typography } from 'antd';
import {
  Shield,
  Lock,
  FileText,
  Users,
  Key,
  BarChart3,
  Zap,
  Check,
} from 'lucide-react';

const { Title, Text } = Typography;

export function Security() {
  const securityItems = [
    { icon: Shield, label: 'SSO' },
    { icon: Lock, label: 'RBAC' },
    { icon: FileText, label: 'Audit Logs' },
    { icon: Users, label: 'Tenant Isolation' },
    { icon: Key, label: 'API Security' },
    { icon: BarChart3, label: 'Usage Monitoring' },
    { icon: Zap, label: 'Rate Limiting' },
    { icon: Check, label: 'Compliance Ready' },
  ];

  return (
    <section
      id="security"
      style={{ padding: '80px 24px', backgroundColor: '#fafafa' }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            Enterprise Security Built In
          </Title>
        </div>

        <Row gutter={[24, 24]}>
          {securityItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Col xs={12} sm={12} md={6} key={item.label}>
                <Card
                  variant="outlined"
                  style={{
                    borderRadius: '12px',
                    textAlign: 'center',
                    height: '100%',
                  }}
                  styles={{
                    body: {
                      padding: '24px',
                    },
                  }}
                >
                  <div
                    style={{
                      color: '#1677ff',
                      marginBottom: '16px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <IconComponent size={40} />
                  </div>
                  <Text
                    strong
                    style={{
                      fontSize: '15px',
                      color: '#262626',
                      display: 'block',
                    }}
                  >
                    {item.label}
                  </Text>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
